import React, { useState, useEffect } from 'react'
import classes from './LoginPage2.module.css'
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, useSearchParams } from 'react-router-dom'
import { loginApi } from '../../http/http'
import { useDispatch, useSelector } from 'react-redux'
import { setUserDetails } from '../../store/slices/userSlice'
import { toast } from 'react-toastify'
import SmallLoader from '../../component/SmallLoader'
import { useTranslation } from 'react-i18next';
import i18n from '../../locales/i18n';
import { setLanguage } from '../../store/slices/languageSlice';

const LoginPage2 = () => {

    const [msisdn, setMsisdn] = useState("");
    const [loginLoading, setLoginLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const dispatch = useDispatch();

    const { userDetails } = useSelector(state => state?.persisted?.userSlice);

    const { selectedLanguage } = useSelector((state) => state.languageSlice);

    const { t } = useTranslation();

    useEffect(() => {
        if (selectedLanguage && i18n.language !== selectedLanguage) {
            i18n.changeLanguage(String(selectedLanguage));
        }
    }, [selectedLanguage, i18n]);

    useEffect(() => {
        if (userDetails?.token) {
            navigate("/home");
        }
    }, [userDetails]);

    useEffect(() => {
        if (searchParams.get("ext_ref")) {
            setExtRef(searchParams.get("ext_ref"));
        } else {
            setSearchParams({ ext_ref: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e) => {
        try {
            e.preventDefault();
            if (msisdn?.trim().length == 0) return;
            setLoginLoading(true);
            const response = await loginApi(msisdn);
            console.log(response, 'response');
            dispatch(setUserDetails(response?.data?.result));
            setLoginLoading(false);
            toast.success(t("21"));
            navigate("/home");
        } catch (error) {
            setLoginLoading(false);
            console.log(error, 'error');

            if (error?.response?.data?.error?.status == 0) {
                toast.error(t("247"));
                navigate("/subscribe");
            }
            else if (error?.response?.data?.error?.status == 1) {
                navigate("/low-balance");
            }
            else {
                toast.error(t("20"));
            }
        }
    }

    return (
        <div className={classes.page}>

            <select
                id="lang"
                name="lang"
                className={classes.dropdown}
                value={selectedLanguage}
                onChange={(event) => {
                    dispatch(setLanguage(event.target.value));
                }}
            >
                <option value="0">English</option>
                <option value="1">French</option>
            </select>

            {/* ══ LEFT — Brand Hero ══ */}
            <div className={classes.leftPanel}>
                <div className={classes.arcCircle} />

                {/* Logo */}
                <div className={classes.logo}>

                    <img src="/assets/images/logo.png" alt="logo" className={classes.logo_img} />
                    {/* <span className={classes.logoIcon}>⚽</span>
                    <span className={classes.logoWordmark}>
                        <em>Football</em> Masters
                    </span> */}
                </div>

                {/* Hero copy */}
                <p className={classes.heroEyebrow}>{t("0")}</p>
                <h1 className={classes.heroTitle}>
                    {t("1")}
                    <span className={classes.accent}>{t("2")}</span>
                </h1>
                <p className={classes.heroSub}>
                    {t("3")}
                </p>

                {/* Feature pills */}
                <div className={classes.pillsRow}>
                    <span className={classes.pill}>{t("4")}</span>
                    <span className={classes.pill}>{t("5")}</span>
                    <span className={classes.pill}>{t("6")}</span>
                </div>

                {/* Stats */}
                {/* <div className={classes.statsRow}>
                    <div className={classes.stat}>
                        <span className={classes.statNum}>2M+</span>
                        <span className={classes.statLabel}>Players</span>
                    </div>
                    <div className={classes.statDivider} />
                    <div className={classes.stat}>
                        <span className={classes.statNum}>₹50L</span>
                        <span className={classes.statLabel}>Prizes Won</span>
                    </div>
                    <div className={classes.statDivider} />
                    <div className={classes.stat}>
                        <span className={classes.statNum}>500+</span>
                        <span className={classes.statLabel}>Matches</span>
                    </div>
                </div> */}
            </div>

            {/* ══ RIGHT — Form ══ */}
            <div className={classes.rightPanel}>
                <div className={classes.formContainer}>

                    <h2 className={classes.formTitle}>
                        {t("7")} <span>{t("8")}</span>
                    </h2>
                    <p className={classes.formSubtitle}>
                        {t("9")}
                    </p>

                    {/* Tab toggle */}
                    <div className={classes.tabToggle}>
                        <button type="button" className={`${classes.tab} ${classes.activeTab}`}>
                            {t("10")}
                        </button>
                        <button
                            type="button"
                            className={classes.tab}
                            onClick={() => navigate(`/?ext_ref=${extRef}`)}
                        >
                            {t("11")}
                        </button>
                    </div>

                    <form onSubmit={handleFormSubmission}>

                        {/* Phone */}
                        <p className={classes.sectionLabel}>{t("12")}</p>
                        <div className={classes.phoneRow}>
                            <div className={classes.countryPill}>
                                <img src="/assets/images/flag.png" alt="India" className={classes.flag} />
                                <span className={classes.dialCode}>+233</span>
                            </div>
                            <input
                                id="msisdn"
                                name="msisdn"
                                type="number"
                                autoFocus
                                onWheel={(e) => e.target.blur()}
                                placeholder={t("13")}
                                className={classes.phoneInput}
                                onChange={(e) => setMsisdn(e.target.value)}
                                value={msisdn}
                            />
                        </div>

                        {/* Terms */}
                        <div className={classes.termsRow}>
                            <input
                                type="checkbox"
                                id="terms"
                                name="Terms & Conditions"
                                value="Terms"
                                className={classes.termsCheck}
                                checked
                                readOnly
                            />
                            <label htmlFor="terms" className={classes.termsText}>
                                {t("14")}{" "}
                                <span className={classes.termsLink}>{t("15")}</span>
                            </label>
                        </div>

                        {/* CTA */}
                        <button type="submit" disabled={loginLoading} className={classes.ctaBtn}>
                            {loginLoading
                                ? <SmallLoader style={{ border: "4px solid #0f0e0d" }} />
                                : <>{t("16")}</>
                            }
                        </button>

                    </form>

                    {/* No account nudge */}
                    <p className={classes.switchPrompt}>
                        {t("17")}{" "}
                        <span
                            className={classes.switchLink}
                            onClick={() => navigate(`/?ext_ref=${extRef}`)}
                        >
                            {t("18")}
                        </span>
                    </p>

                    {/* ── Copyright footer ── */}
                    <div className={classes.copyrightFooter}>
                        <div className={classes.copyrightDivider} />
                        <div className={classes.copyrightInner}>
                            <span className={classes.copyrightBadge}>
                                <span className={classes.copyrightBadgeIcon}>⚽</span>
                                Football Masters
                            </span>
                            <p className={classes.copyrightText}>
                                © {new Date().getFullYear()} Rainboo Softmate Pvt Ltd
                            </p>
                            <p className={classes.copyrightSub}>All rights reserved</p>
                        </div>
                    </div>


                    {/* Trust strip */}
                    {/* <div className={classes.trustStrip}>
                        <span className={classes.trustItem}>🔒 Secure Login</span>
                        <span className={classes.trustDot} />
                        <span className={classes.trustItem}>✓ No Password</span>
                        <span className={classes.trustDot} />
                        <span className={classes.trustItem}>💬 24/7 Support</span>
                    </div> */}

                </div>
            </div>

        </div>
    )
}

export default LoginPage2